import { getSizeChartByCountryCode } from "../services/centra/mappers/utils/get-sizechart-by-country-code";

const SIZECHART_FACETS = [
  "sizechart.sizechart_france.cup_type",
  "sizechart.sizechart_italy.cup_type",
  "sizechart.sizechart_uk.cup_type",
  "sizechart.sizechart_us.cup_type",
  "sizechart.sizechart_aus.cup_type",
  "sizechart.sizechart_eu.cup_type",
  "sizechart.sizechart_france.type",
  "sizechart.sizechart_italy.type",
  "sizechart.sizechart_uk.type",
  "sizechart.sizechart_us.type",
  "sizechart.sizechart_aus.type",
  "sizechart.sizechart_eu.type",
];

export const getSizechartFacetExclusions = (countryCode: string): string[] => {
  const activeSizeChart = getSizeChartByCountryCode(countryCode);

  return SIZECHART_FACETS.filter((facet) => !facet.includes(activeSizeChart));
};
